import { render } from "./ContactContent.vue?vue&type=template&id=4df522a5&ts=true"
import script from "./ContactContent.vue?vue&type=script&lang=ts"
export * from "./ContactContent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__